import { put } from "redux-saga/effects";
import { registerMemberEdc } from "../../Services";

export function* registerEdcMemberSaga(action) {
  const payload = action.payload;

  try {
    // console.log("payload saga", payload);
    const res = yield registerMemberEdc(payload);
    yield put({ type: "REQ_REGISTER_MEMBER_EDC_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_REGISTER_MEMBER_EDC_FAILED", errData: e });
  }
}
